<template>
    <div class="ba6-website-builder-card">
        <builderall-loader :loading="showLoading">
            <div v-if="view.routes.upgrade_website_builder == null && hasResponse" class="ba6-card">
                <div class="ba6-top">
                    <a :href="view.routes.website_builder" class="ba6-title">{{ t.website_builder }}</a>
                </div>
                <hr class="ba6-card-line">
                <div class="ba6-main-website-builder">
                    <div class="ba6-image"></div>
                    <div class="ba6-table">
                        <div class="ba6-gray-box">
                            <span>{{ t.website_name }}</span>
                            <span>{{ t.number_of_pages }}</span>
                        </div>
                        <div class='ba6-list'>
                            <a 
                                v-for="w,i in websiteBuilderData.websites" :key="i" 
                                :href="w.link" 
                                target="_blank" 
                                class="ba6-link"
                            >
                                <div class="ba6-texts">
                                    <span class="ba6-normal" v-text="w.title"></span>
                                    <a :href="w.link" target="_blank" class="ba6-url" v-text="w.url"></a>
                                </div>
                                <hr>
                                <span class="ba6-count" v-text="w.pages"></span>
                            </a>
                        </div>
                    </div>
                </div>
                <a 
                    v-if="view.routes.upgrade_website_builder == null && hasResponse" 
                    :href="view.routes.website_builder" 
                    class="ba6-view-all" 
                    v-text="t.view_all_notifications"
                ></a>
            </div>
            <div v-else class="ba6-card empty-data">
                <div class="image-content">
                    <img src="https://cheetah.builderall.com/franquias/2/7291108/editor-html/12797261.png">
                </div>
                <div class="empty-content">
                    <builderall-icon class="tool-icon" code='sitebuilder'></builderall-icon>
                    <h4 v-text="t.website_builder"></h4>
                    <p v-text="decodeString(t.website_builder_card_description)"></p>
                    <a 
                        class="ba-btn ba-blue ba-md"
                        :href="view.routes.upgrade_website_builder != null ? view.routes.upgrade_website_builder : view.routes.website_builder+'?redirect_url=/create-website?step=template'"
                    >
                        {{ t.label_create_a_website }}
                        <builderall-icon code='arrow-right'></builderall-icon>
                    </a>
                </div>
            </div>
        </builderall-loader>
    </div>
</template>

<script>
    import { bus } from '../../../../office';
    export default {
        name: "ba6-website-builder-card",
        props: ['view'],
        data() {
            return {
                websiteBuilderData: [],
                showLoading: false,
                t: null,
                hasResponse: false
            }
        },
        created(){
            this.t = this.view.translations
            if(this.view.routes.upgrade_website_builder == null){
                this.showLoading = true
                bus.$on("websiteBuilderRequest", val => {
                    this.websiteBuilderData = val
                    this.hasResponse = Object.keys(val.websites).length > 0 && val.websites
                    this.showLoading = false
                });
            }
        },
        destroyed() {
            bus.$off('websiteBuilderRequest')
        },
        methods: {
          decodeString(string) {
            return new DOMParser().parseFromString(string, 'text/html').querySelector('body').textContent
          },
        }
    }
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/dashboard/website-builder/WebsiteBuilderCard.vue